import { combineReducers } from 'redux';
import { authReducer } from './authReducer';
import { flowReducer } from './flowReducer';
import { settingsReducer } from './settingsReducer';
import { statusReducer } from './statusReducer';
import { traceabilityReducer } from './traceabilityReducer';
import { boardsReducer } from './boardsReducer';
import { docQueryReducer } from './docQueryReducer';
import { menuReducer } from './menuReducer';
import { usersReducer } from './usersReducer';
import { sharedViewsReducer } from './sharedViewsReducer';
import { signDocumentReducer } from './signDocumentReducer';
import { configurationCountReducer } from './configurationCountReducer';
import { proveedorReducer } from './proveedorReducer';
import { approvalReducer } from './approvalReducer';
import { groupReducer } from './groupReducer';
import { chartsReducer } from './chartsReducer';
import { actionTypes } from '../contants/actionTypes';

const appReducer = combineReducers({
    auth: authReducer,
    flows: flowReducer,
    settings: settingsReducer,
    status: statusReducer,
    traceability: traceabilityReducer,
    board: boardsReducer,
    docs: docQueryReducer,
    users: usersReducer,
    sharedViews: sharedViewsReducer,
    menu: menuReducer,
    signDocument: signDocumentReducer,
    configurationCount: configurationCountReducer,
    proveedor: proveedorReducer,
    approval: approvalReducer,
    group: groupReducer,
    charts: chartsReducer
})


export const rootReducer = (state, action) => {
    if (action.type === actionTypes.authLogout) {
        state = undefined;
    }
    return appReducer(state, action);
};